import React from 'react';
import { createRoot } from 'react-dom/client';
import providerHOC from 'app/utils/providerHOC/providerHOC';
import store from './productsStore';
import ProductsApp from './productsApp';
import ProductsHOC from './productsHOC';
import BreadCrumbs from './components/breadcrumbs/breadcrumbs';
import PlpCategoryDetails from './components/plpCategoryDetails/PlpCategoryDetails';

const ProductsRoot = providerHOC(store)(ProductsHOC(ProductsApp));
createRoot(document.getElementById('plp')).render(<ProductsRoot />);

const breadcrumbsNode = document.getElementById('breadcrumbs');
const rootBreadcrumbs = createRoot(breadcrumbsNode);
const BreadCrumbsRoot = providerHOC(store)(BreadCrumbs);
rootBreadcrumbs.render(<BreadCrumbsRoot />);

const plpCategoryDetails = document.getElementById('plpCategoryDetails');
const rootPageCategory = createRoot(plpCategoryDetails);
rootPageCategory.render(<PlpCategoryDetails />);
